<!-- The Today view (E4 RF-36 to RF-41). Hyper cards; Material Design Icons throughout. -->
<div class="row">
  <div [class]="selectedTask ? 'col-xl-8' : 'col-12'">
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <!-- RF-37: "X de Y". -->
            @if (reading) {
              <span class="badge campaign-badge is-run" [attr.aria-label]="'task.today.progress' | translate: { concluded: reading.progress.concluded, scheduled: reading.progress.scheduled }">
                <i class="mdi mdi-progress-check me-1"></i>
                {{ 'task.today.progress' | translate: { concluded: reading.progress.concluded, scheduled: reading.progress.scheduled } }}
              </span>
            }
            <!-- RF-38: the time left until the next timed commitment, and who owns it. -->
            @if (nextCountdown; as countdown) {
              <span class="text-muted font-13">
                <i class="mdi mdi-timer-outline me-1"></i>{{ countdown.key | translate: countdown.params }}
                @if (nextResponsible) {
                  · {{ nextResponsible }}
                }
              </span>
            } @else if (reading) {
              <span class="text-muted font-13">
                <i class="mdi mdi-timer-off-outline me-1"></i>{{ 'task.today.noNext' | translate }}
              </span>
            }
          </div>
          <button class="btn btn-outline-primary" type="button" (click)="refresh()" [disabled]="loading">
            @if (!loading) {
              <i class="mdi mdi-refresh"></i>
              {{ 'task.today.refresh' | translate }}
            } @else {
              <mat-spinner [diameter]="20" mode="indeterminate" />
            }
          </button>
        </div>

        @if (failed && !reading) {
          <div class="alert alert-danger py-2 mb-0" role="alert">
            <i class="mdi mdi-alert-circle-outline me-1"></i>{{ 'task.today.loadError' | translate }}
          </div>
        } @else if (!reading) {
          <content-loading-list />
        } @else if (isEmpty) {
          <empty-records-component icon="ri-task-line" [message]="'task.today.empty' | translate" />
        } @else {
          @for (group of groups; track group.key) {
            @if (activitiesOf(group.key).length > 0) {
              <h5 class="header-title d-flex align-items-center gap-2 mt-3 mb-2">
                <i class="mdi" [ngClass]="group.icon"></i>
                {{ group.label | translate }}
                <span class="badge bg-soft-secondary text-muted">{{ activitiesOf(group.key).length }}</span>
              </h5>
              <app-activity-list
                [activities]="activitiesOf(group.key)"
                [selectable]="true"
                [selectedId]="$safeNavigationMigration(selectedTask?._id)"
                [showResponsible]="!!reading.responsible === false"
                [timedFormat]="group.key === 'overdue' ? 'DD/MM' : 'HH:mm'"
                dateFormat="DD/MM"
                (changed)="onChanged()"
                (selected)="onSelected($event)"
              />
            }
          }
        }
      </div>
    </div>
  </div>

  <!-- RF-40: the deal's context, in place. The signals come from the existing deal radar. -->
  @if (selectedTask) {
    <div class="col-xl-4">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="header-title mb-0">{{ 'task.today.contextTitle' | translate }}</h4>
            <button type="button" class="btn-close" (click)="closePanel()" [attr.aria-label]="'task.today.close' | translate"></button>
          </div>

          @if (panelLoading) {
            <content-loading-list />
          } @else if (panelHidden) {
            <div class="alert alert-secondary py-2 mb-0" role="alert">
              <i class="mdi mdi-eye-off-outline me-1"></i>{{ 'task.today.contextHidden' | translate }}
            </div>
          } @else if (!panelCard) {
            <p class="text-muted font-13 mb-0">{{ 'task.today.contextHint' | translate }}</p>
          } @else {
            <h5 class="mb-1">{{ panelCard.name }}</h5>
            @if (panelStageName) {
              <p class="text-muted font-13 mb-2">
                <i class="mdi mdi-view-column-outline me-1"></i>{{ 'task.today.stage' | translate }}: {{ panelStageName }}
              </p>
            }
            <!-- Design (canvas "Hoje"): panel arrangement — wrapping quality chips, no commitment slot (the list below owns it). -->
            <app-card-radar [card]="panelCard" [panel]="true" />

            <hr class="my-3" />
            <h6 class="text-uppercase text-muted font-11 fw-bold mb-2">{{ 'task.today.upcoming' | translate }}</h6>
            <app-activity-list
              [activities]="upcoming"
              [showDeal]="false"
              timedFormat="DD/MM HH:mm"
              dateFormat="DD/MM"
              (changed)="onChanged()"
            />
          }
        </div>
      </div>
    </div>
  }
</div>
